import { render } from "./MoviePage.vue?vue&type=template&id=3d992e7d&scoped=true"
import script from "./MoviePage.vue?vue&type=script&lang=js"
export * from "./MoviePage.vue?vue&type=script&lang=js"

import "./MoviePage.vue?vue&type=style&index=0&id=3d992e7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d992e7d"]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QVideo from 'quasar/src/components/video/QVideo.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QBtnToggle,QDialog,QCard,QBar,QSpace,QBtn,QResizeObserver,QVideo});qInstall(script, 'directives', {ClosePopup});
